













































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import BaseContainer from '@/components/BaseContainer.vue';
import StatusPanel from '@/views/Inquiry/components/StatusPanel.vue';
import BaseInfoPanel from '@/components/BaseInfoPanel.vue';
import { Inquiry, Carrier } from '@/http';
import ButtonPanel from '@/components/ButtonPanel.vue';
import CspDialog from '@/components/CspDialog.vue';
import { formRules } from '@/common/util/validator';
import { default as DataPanel } from '@/components/DataPanel.vue';
import publicFunc from '../../common/util/publicFunc';
@Component({
    components: {
        BaseContainer,
        StatusPanel,
        BaseInfoPanel,
        ButtonPanel,
        CspDialog,
        DataPanel,
    },
})
export default class InquiryDetail extends Vue {
    toogleExpand(row) {
        let $table = this.$refs.multipleTableTop;
        $table.toggleRowExpansion(row);
    }

    public checkList: any = [];
    public isShowBargaining = false;
    public bargainingClose() {
        this.isShowBargaining = false;
    }
    public bargainingData: any = [];
    numberChange(i) {
        let temp = i.price.toString();
        temp = temp.replace(/。/g, '.');
        temp = temp.replace(/[^\d.]/g, ''); //清除"数字"和"."以外的字符
        temp = temp.replace(/^\./g, ''); //验证第一个字符是数字
        temp = temp.replace(/\.{2,}/g, ''); //只保留第一个, 清除多余的
        temp = temp.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
        temp = temp.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //
        i.price = temp;
    }
    public async saveBargaining(priceInfo) {
        const pricestr = priceInfo.every((item, index) => {
            if (item.price === undefined) {
                return false;
            } else {
                return true;
            }
        });
        console.log('bargainingData' + JSON.stringify(this.bargainingData));
        if (this.yijiaCurrentBtn.length == 0) {
            this.$message.warning('请选择承运商');
        } else if (!pricestr) {
            this.$message.error('议价金额必填!');
        } else {
            let carrierIds = [];
            this.yijiaCurrentBtn.forEach((i) => {
                let res = this.allCarrierBtnListId.filter((v) => v.name == i)[0];
                if (res) {
                    carrierIds.push(res.id);
                }
            });
            try {
                await Inquiry.AddNegotiateQuote({
                    inquiryId: this.id,
                    carrierIds: carrierIds,
                    quotes: this.bargainingData,
                });
                this.$message.success('操作成功');
                this.isShowBargaining = false;
                this.init();
            } catch (e) {
                this.isShowBargaining = false;
                this.init();
            }

            // this.$router.push('/SingleInquiry');
        }
    }
    public yijiaCarrierBtnList: any = [];
    public openBargaining() {
        this.isShowBargaining = true;
        this.bargainingData = [];
        this.tableList.forEach((item) => {
            this.bargainingData.push({
                carLength: item.carLength,
                price: undefined,
            });
        });
        console.log('this.bargainingData' + JSON.stringify(this.bargainingData));
        // let currBtnName = [];
        // this.inquiryCarrierList.forEach((item) => {
        //     currBtnName.push(item.carrierName);
        // });
        this.yijiaCurrentBtn = JSON.parse(JSON.stringify(this.yijiaCarrierBtnList));

        // console.log('allCarrierBtnList'+JSON.stringify(this.allCarrierBtnList))
        //   console.log('this.currentBtn'+JSON.stringify(this.currentBtn))
        // // this.currentBtn.forEach((i) => {
        // //     let res = this.allCarrierBtnList.filter((v) => v == i)[0];
        // //     if(res){
        // //          this.yijiaCarrierBtnList.push(res);
        // //     }

        // // });
        // console.log('this.curCarrierBtnList'+JSON.stringify(this.curCarrierBtnList))
    }

    public historyData: any = {};
    public isShowHistory: boolean = false;
    public openHistory() {
        this.isShowHistory = true;
    }
    public historyClose() {
        this.isShowHistory = false;
    }

    public winVisible = false;
    public formDataWin: any = { winRemark: '' };
    public loading: boolean = false;
    public adjustCarrierVisible = false;
    public requoteVisible = false;
    public title: string = '1.在线查看询价信息以及询价进度  2.询价状态为报价中，支持制造企业调整承运商、一键催报、承运商重新报价、一键否决等操作';
    public cspdiaConfig: any = {
        cspDialogVisible: false,
        title: '询价单终结',
        content: '确认终结询价单？',
    };
    public publicFunc: any = publicFunc;
    public formRules = formRules;
    public id: any = '';
    public name: any = '';
    public detailData: any = {};
    public goodsList: any = [];
    public formDataRequote: any = {};
    public async created() {
        this.id = this.$route.query.id;
        this.name = this.$route.query.name;
        let res = await Carrier.GetList({ count: -1 });
        this.carrierList = res.data;
        this.reload();
    }

    public async init() {
        this.id = this.$route.query.id;
        this.name = this.$route.query.name;
        let res = await Carrier.GetList({ count: -1 });
        this.carrierList = res.data;
        this.reload();
    }

    toContract() {
        this.$router.push({
            path: '/contractManage',
        });
    }

    toOrderPage() {
        this.$router.push({
            path: '/addOrder',
            query: {
                inquiryId: this.id,
                type: 'inquiry',
            },
        });
    }

    is150 = false;
    // 方法
    public ratio = 0;
    detectZoom() {
        this.ratio = 0;
        const screen: any = window.screen;
        const ua = navigator.userAgent.toLowerCase();
        if (window.devicePixelRatio !== undefined) {
            this.ratio = window.devicePixelRatio;
        } else if (~ua.indexOf('msie')) {
            if (screen.deviceXDPI && screen.logicalXDPI) {
                this.ratio = screen.deviceXDPI / screen.logicalXDPI;
            }
        } else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
            this.ratio = window.outerWidth / window.innerWidth;
        }
        if (this.ratio) {
            this.ratio = Math.round(this.ratio * 100);
        }
        console.log('this.ratio' + this.ratio);
        if (this.ratio >= 140) {
            this.is150 = true;
        } else {
            this.is150 = false;
        }
    }

    public allCarrierBtnList: any = [];
    public allCarrierBtnListId: any = [];
    public tableList: any = [];
    public inquiryCarrierList: any = [];
    public ccdata: any = {};
    public allData: any = [];
    reload() {
        this.tableData = [];
        this.tableList = [];
        this.allData = [];
        this.inquiryCarrierList = [];
        this.isChangeCarrier = false;
        this.ccdata = {};
        Inquiry.GetDetail(this.id).then((res) => {
            this.detailData = res;
            this.inquiryCarrierList = res.inquiryCarrierList;
            let carLengthArr = res.carLength.split(',');
            this.yijiaCarrierBtnList = [];
            if (this.detailData.inquiryQuotes && this.detailData.inquiryQuotes.length > 0) {
                this.detailData.inquiryQuotes.forEach((i) => {
                    if (i.isNew) {
                        this.yijiaCarrierBtnList.push(i.carrierName);
                    }
                });
            }

            carLengthArr.forEach((item) => {
                this.tableList.push({
                    carLength: item,
                    price: '',
                });
            });
            if (this.detailData.inquiryQuotes && this.detailData.inquiryQuotes.length > 0) {
                this.detailData.inquiryQuotes.forEach((item) => {
                    // this.allData.push({
                    //     carrierName: item.carrierName,
                    //     timesIndex: item.timesIndex,
                    //     quotes: item.quotes,
                    //     isWin: item.isWin,
                    //     isNew: item.isNew,
                    //     isNegotiatedPrice:item.isNegotiatedPrice,
                    //     id: item.id,
                    //     carrierId: item.carrierId,
                    //     hasOldTimes: item.hasOldTimes,
                    // });
                    if (item.isNew) {
                        this.tableData.push({
                            carrierName: item.carrierName,
                            timesIndex: item.timesIndex,
                            quotes: item.quotes,
                            isWin: item.isWin,
                            isNegotiatedPrice: item.isNegotiatedPrice,
                            isNew: item.isNew,
                            remark: item.remark,
                            isShowWinBtn: item.isShowWinBtn,
                            isAgree: item.isAgree,
                            carrierId: item.carrierId,
                            id: item.id,
                            hasOldTimes: item.hasOldTimes,
                        });
                    } else {
                        let tempArr = [];
                        if (this.ccdata[item.carrierId] && this.ccdata[item.carrierId].length > 0) {
                            this.ccdata[item.carrierId].forEach((i) => {
                                tempArr.push(i);
                            });
                            // tempArr.push(this.ccdata[item.carrierId]);
                            tempArr.push({
                                carrierName: item.carrierName,
                                timesIndex: item.timesIndex,
                                quotes: item.quotes,
                                isWin: item.isWin,
                                isShowWinBtn: item.isShowWinBtn,
                                isAgree: item.isAgree,
                                remark: item.remark,
                                carrierId: item.carrierId,
                                isNegotiatedPrice: item.isNegotiatedPrice,
                                isNew: item.isNew,
                                id: item.id,
                                hasOldTimes: item.hasOldTimes,
                            });
                        } else {
                            tempArr.push({
                                carrierName: item.carrierName,
                                timesIndex: item.timesIndex,
                                quotes: item.quotes,
                                isAgree: item.isAgree,
                                isShowWinBtn: item.isShowWinBtn,
                                isWin: item.isWin,
                                carrierId: item.carrierId,
                                remark: item.remark,
                                isNegotiatedPrice: item.isNegotiatedPrice,
                                isNew: item.isNew,
                                id: item.id,
                                hasOldTimes: item.hasOldTimes,
                            });
                        }
                        // this.ccdata[item.carrierId] = this.getSpanArr(JSON.parse(JSON.stringify(tempArr)));
                        this.ccdata[item.carrierId] = JSON.parse(JSON.stringify(tempArr));
                    }
                });
            }
            let skip = 0;
            this.detailData.goodsList.map((item, index) => {
                item.index = skip++ + 1;
            });
            this.goodsList = this.detailData.goodsList;
            this.getSpanArr(this.tableData);
            // this.ccdata = JSON.parse(JSON.stringify(this.tableData));
            // this.getSpanArr(this.ccdata);
            this.formData.carrierIds = [];
            res.inquiryCarrierList.forEach((item) => {
                this.formData.carrierIds.push(item.carrierId);
            });
            this.dynamicTags = [];

            this.formData.carrierIds.forEach((item) => {
                let res = this.carrierList.filter((v) => v.id == item)[0];
                this.dynamicTags.push({
                    name: res.name,
                    id: res.id,
                });
            });

            this.allCarrierBtnList = [];
            this.allCarrierBtnListId = [];
            this.carrierList.forEach((i) => {
                this.allCarrierBtnList.push(i.name);
                this.allCarrierBtnListId.push({
                    id: i.id,
                    name: i.name,
                });
            });
        });
    }

    public curCarrierBtnList = [];
    public async mounted() {
        this.detectZoom();
        this.$nextTick(() => {
            window.addEventListener('resize', () => {
                // 监听浏览器窗口大小改变
                this.detectZoom();
                // 浏览器变化执行动作
            });
        });
    }
    public spanArr = [];
    public pos = 0;
    getSpanArr(data) {
        this.spanArr = [];
        for (var i = 0; i < data.length; i++) {
            if (i === 0) {
                this.spanArr.push(1);
                this.pos = 0;
            } else {
                // 判断当前元素与上一个元素是否相同  inAccessCode（批次字段）
                if (data[i].carrierName === data[i - 1].carrierName) {
                    this.spanArr[this.pos] += 1;
                    this.spanArr.push(0);
                } else {
                    this.spanArr.push(1);
                    this.pos = i;
                }
            }
        }
    }

    public requoteClose() {
        this.requoteVisible = false;
    }

    public async saveRequote() {
        if (this.currentBtn.length == 0) {
            this.$message.warning('请选择承运商');
        } else {
            let carrierIds = [];
            this.currentBtn.forEach((i) => {
                let res = this.allCarrierBtnListId.filter((v) => v.name == i)[0];
                if (res) {
                    carrierIds.push(res.id);
                }
            });
            await Inquiry.BackQuote({
                inquiryId: this.id,
                carrierIds: carrierIds,
            });
            this.$message.success('定向询价承运商调整成功！');
            this.$router.push('/SingleInquiry');
        }
    }
    public $refs: {
        formData: HTMLFormElement;
        multipleTableTop: HTMLFormElement;
        formDataWin: HTMLFormElement;
    };

    public saveAdjustCarrier() {
        this.$refs.formData.validate(async (valid) => {
            if (valid) {
                await Inquiry.UpdateCarriers({
                    inquiryId: this.id,
                    carrierIds: this.formData.carrierIds,
                });
                this.$message.success('定向询价承运商调整成功！');
                this.$router.push('/SingleInquiry');
            }
        });
    }

    public isChangeCarrier = false;
    public changeCarrier() {
        this.isChangeCarrier = true;
    }
    public formData: any = { carrierIds: [] };
    public dynamicTags = [];
    handleDelTag(tag) {
        let flag = true;
        try {
            this.detailData.inquiryQuotes.forEach((i) => {
                if (i.carrierName == tag.name) {
                    flag = false;
                    this.$message.warning('该承运商已报价，无法删除!');
                    throw Error();
                }
            });
        } catch (e) {}
        if (flag) {
            this.formData.carrierIds = [];
            this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
            this.dynamicTags.forEach((item) => {
                this.formData.carrierIds.push(item.id);
            });
            this.oldData = JSON.parse(JSON.stringify(this.formData.carrierIds));
        }
    }
    public carrierChange(data) {
        let flag = true;
        let arr1 = [];
        let arr2 = [];
        if (this.formData.carrierIds.length >= this.oldData) {
            arr1 = this.formData.carrierIds;
            arr2 = this.oldData;
        } else {
            arr1 = this.oldData;
            arr2 = this.formData.carrierIds;
        }
        let res = [];
        res.push(
            arr1.filter((item) => {
                return !arr2.includes(item);
            })
        );
        try {
            this.detailData.inquiryQuotes.forEach((i) => {
                if (i.carrierId == res[0]) {
                    flag = false;
                    this.$message.warning('该承运商已报价，无法删除!');
                    this.formData.carrierIds = JSON.parse(JSON.stringify(this.oldData));
                    throw Error();
                }
            });
        } catch (e) {}
        if (flag) {
            this.dynamicTags = [];
            this.formData.carrierIds.forEach((item) => {
                let res = this.carrierList.filter((v) => v.id == item)[0];
                this.dynamicTags.push({
                    name: res.name,
                    id: res.id,
                });
            });
            this.oldData = JSON.parse(JSON.stringify(this.formData.carrierIds));
        }
    }
    public tableData: any = [];
    public colData: any = [];

    public adjustCarrierClose() {
        this.$refs.formData.resetFields();
        this.adjustCarrierVisible = false;
    }

    public oldData: any = [];
    //调整承运商
    adjustCarrier() {
        this.adjustCarrierVisible = true;
        this.oldData = JSON.parse(JSON.stringify(this.formData.carrierIds));
        this.dynamicTags = [];

        this.formData.carrierIds.forEach((item) => {
            let res = this.carrierList.filter((v) => v.id == item)[0];
            this.dynamicTags.push({
                name: res.name,
                id: res.id,
            });
        });
    }
    //一键催报
    async reminder() {
        await Inquiry.Urge(this.id);
        this.$message.warning('单笔询价催报成功！');
    }
    //承运商重新报价
    requote() {
        this.requoteVisible = true;
        let currBtnName = [];
        this.inquiryCarrierList.forEach((item) => {
            currBtnName.push(item.carrierName);
        });
        this.currentBtn = currBtnName;

        this.curCarrierBtnList = [];
        this.currentBtn.forEach((i) => {
            let res = this.allCarrierBtnList.filter((v) => v == i)[0];
            if (res) {
                this.curCarrierBtnList.push(res);
            }
        });
    }
    //一键否决
    reject() {
        this.$confirm('承运商报价全部拒绝!', '一键否决', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        })
            .then(() => {
                Inquiry.RejectAllQuote(this.id).then(() => {
                    this.$message.success('单笔询价招标失败！');
                    this.$router.push('/SingleInquiry');
                });
            })
            .catch(() => {});
    }
    loadingEffect = [];
    public winTip: any = '';
    public winRemark: any = '';

    public timesIndex: any = '';
    public tag = false;
    public carrierId: any = '';
    public bidding(row, tag) {
        this.tag = tag;
        this.timesIndex = row.timesIndex;
        this.carrierId = row.quotes[0].carrierId;
        console.log('row' + JSON.stringify(row));
        if (tag) {
            let str = '';
            row.quotes.forEach((item) => {
                if (item.price) {
                    str += item.carLength + '中标价:' + item.price+'元/车' + ' , ';
                }
            });
            // str = str.substring(0, str.lastIndexOf(','));
            this.winTip = str + '   确认' + row.carrierName + '中标?';
        } else {
            this.winTip = '确认取消' + row.carrierName + '中标?';
        }

        this.formDataWin.winRemark = '';
        this.winVisible = true;
    }
    public async saveWin() {
        this.$refs.formDataWin.validate(async (valid) => {
            if (valid) {
                if (this.tag) {
                    await Inquiry.Win({
                        inquiryId: this.id,
                        carrierId: this.carrierId,
                        timesIndex: this.timesIndex,
                        winRemark: this.formDataWin.winRemark,
                    });
                    this.$message.success('询价单招标成功！');
                } else {
                    await Inquiry.CancelWin({
                        inquiryId: this.id,
                        carrierId: this.carrierId,
                        timesIndex: this.timesIndex,
                        cancelRemark: this.formDataWin.winRemark,
                    });
                    this.$message.success('询价单取消成功!');
                }

                this.winVisible = false;
                this.init();
                // this.$router.push('/SingleInquiry');
            }
        });
    }
    winClose() {
        this.formDataWin.winRemark = '';
        this.winTip = '';
        this.$refs.formDataWin.resetFields();
        this.winVisible = false;
    }
    cellClass({ row, column, rowIndex, columnIndex }) {
        if (this.detailData.statusStr == '招标成功') {
            if (row.isWin && columnIndex != 0) {
                return 'font-weight:700;color:#30AD83';
            } else {
                return '';
            }
        }
    }

    /**新增询价单 */
    public async addInquiry() {
        this.dialogBtn = 'save';
        this.cspdiaConfig = {
            cspDialogVisible: true,
            title: '询价单发布',
            content: '确认发布询价单？',
        };
    }

    editInquiry() {
        this.$router.push({
            path: '/addInquiry',
            query: {
                id: this.id,
                type: 'edit',
            },
        });
    }
    public dialogBtn: string = '';
    /**终结询价单 */
    confirmOk3() {
        Inquiry.EndInquiry(this.id).then(() => {
            this.$message.success('询价单终结成功');
            this.$router.push('/SingleInquiry');
        });
        this.dialogConfig3 = {
            title: '',
            show: false,
        };
    }
    endInquiry() {
        this.dialogConfig3 = {
            title: '终结询价单',
            show: true,
        };
        // this.$confirm('确认终结该询价单?', '询价单终结', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning',
        // })
        //     .then(() => {
        //         Inquiry.EndInquiry(this.id).then(() => {
        //             this.$message.success('询价单终结成功');
        //             this.$router.push('/SingleInquiry');
        //         });
        //     })
        //     .catch(() => {});
    }
    public dialogConfig2 = {
        title: '',
        show: false,
    };
    public dialogConfig3 = {
        title: '',
        show: false,
    };
    confirmClose2() {
        this.dialogConfig2 = {
            title: '',
            show: false,
        };
    }
    confirmClose3() {
        this.dialogConfig3 = {
            title: '',
            show: false,
        };
    }
    confirmOk2() {
        Inquiry.DelInquiry(this.id).then(() => {
            this.$message.success('询价单删除成功');
            this.$router.push('/SingleInquiry');
        });
        this.dialogConfig2 = {
            title: '',
            show: false,
        };
    }
    /**删除询价单 */
    deleteInquiry() {
        this.dialogConfig2 = {
            title: '删除询价单',
            show: true,
        };
        // this.$confirm('确认删除该询价单?', '询价单删除', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning',
        // })
        //     .then(() => {
        //         Inquiry.DelInquiry(this.id).then(() => {
        //             this.$message.success('询价单删除成功');
        //             this.$router.push('/SingleInquiry');
        //         });
        //     })
        //     .catch(() => {});
    }
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        if (columnIndex === 1) {
            const _row = this.spanArr[rowIndex];
            const _col = _row > 0 ? 1 : 0;
            return {
                rowspan: _row,
                colspan: _col,
            };
        }
    }
    objectSpanMethod2({ row, column, rowIndex, columnIndex }) {
        if (columnIndex === 0) {
            if (rowIndex % 100 === 0) {
                return {
                    rowspan: 100,
                    colspan: 1,
                };
            } else {
                return {
                    rowspan: 0,
                    colspan: 0,
                };
            }
        }
    }
    public currentBtn: any = [];
    public yijiaCurrentBtn: any = [];

    public editForm: any = {};
    public fileList: any = [];
    public goodsForm: any = {};

    cspdiaClose() {}

    back() {
        this.$router.push('/singleInquiry');
    }

    viewFile(item) {
        if (publicFunc.getExtension2(item.name)) {
            window.open(`https://view.officeapps.live.com/op/view.aspx?src=${item.path}`);
        } else {
            window.open(item.path);
        }
    }
    rowStyle({ row, rowIndex }) {
        Object.defineProperty(row, 'rowIndex', {
            value: rowIndex,
            writable: true,
            enumerable: false,
        });
    }
    public processStatus: boolean = false;
    public processList = [];
    public takeTime = null;
    public firData = null;
    public SecData = null;
    public d: number = 0;
    public h: number = 0;
    public m: any = 0;
    public s: any = 0;
    public time: string = '';
    public timer: any = null;

    async getprocess(e) {
        e.stopPropagation();
        this.processStatus = !this.processStatus;
        if (this.processStatus) {
            this.processList = [];
            let res = await Inquiry.GetTracks(this.id);
            this.processList = res.tracks;
            this.takeTime = this.processList[0].time;
            this.firData = this.processList[0].time;
            this.SecData = this.processList[this.processList.length - 1].time;
            if (res.isEnd) {
                this.countTime2();
            } else {
                this.countTime();
            }

            console.log('this.processList' + JSON.stringify(this.processList));
        }
    }

    countTime() {
        //获取当前时间
        var date = new Date();
        var now = date.getTime();
        //设置截止时间
        var endDate = new Date(Date.parse(this.SecData.replace(/-/g, '/')));
        var end = endDate.getTime();
        //时间差
        var leftTime = now - end;
        //定义变量 d,h,m,s保存倒计时的时间

        this.d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
        this.h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
        this.m = Math.floor((leftTime / 1000 / 60) % 60);
        this.s = Math.floor((leftTime / 1000) % 60);
        this.time = '耗时' + this.d + '天' + this.h + '小时' + this.m + '分' + this.s + '秒';
        this.timer = setTimeout(this.countTime, 1000);
    }

    countTime2() {
        var nowData = new Date(Date.parse(this.firData.replace(/-/g, '/')));
        var now = nowData.getTime();
        var endDate = new Date(Date.parse(this.SecData.replace(/-/g, '/')));
        var end = endDate.getTime();
        var leftTime = now - end;
        //定义变量 d,h,m,s保存倒计时的时间
        console.log('leftTime' + leftTime);

        this.d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
        this.h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
        this.m = Math.floor((leftTime / 1000 / 60) % 60);
        this.s = Math.floor((leftTime / 1000) % 60);
        this.time = '耗时' + this.d + '天' + this.h + '小时' + this.m + '分' + this.s + '秒';
    }
    @Watch('processStatus')
    processStatusChange() {
        if (this.processStatus == false) {
            if (this.timer) {
                clearTimeout(this.timer);
            }
        }
    }

    public carrierList = [];
    getCarrierList() {
        // CspInquiry.getLoadType({ typeName: '装车要求' }).then((res) => {
        //     this.carrierList = res.map((v) => {
        //         return v.stringData;
        //     });
        // });
    }
    updateBtn(item, index) {
        console.log('item' + JSON.stringify(item));
        if (this.currentBtn.includes(item)) {
            this.currentBtn.splice(this.currentBtn.indexOf(item), 1);
        } else {
            this.currentBtn.push(item);
        }
    }
    updateBtn2(item, index) {
        console.log('item' + JSON.stringify(item));
        if (this.yijiaCurrentBtn.includes(item)) {
            this.yijiaCurrentBtn.splice(this.yijiaCurrentBtn.indexOf(item), 1);
        } else {
            this.yijiaCurrentBtn.push(item);
        }
    }

    downLoad(path) {
        window.open(path);
    }
    public total = 0;
    public paginationOptions = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public pageSizes = [10];
    public lastPageNum = 0;
    public pageSize: number = 10;
    public firstPageBtnDisabled = true;
    public lastPageBtnDisabled = false;
    public handleCurrentChange(val) {
        console.log('onPaginationChange', val);
        this.firstPageBtnDisabled = val === 1 ? true : false;
        this.lastPageBtnDisabled = val === Math.ceil(this.total / this.paginationOptions.count) ? true : false;
        this.paginationOptions.currentPage = val;
        this.paginationOptions.skip = (this.paginationOptions.currentPage - 1) * this.paginationOptions.count;
        console.log('this.paginationOptions~', this.paginationOptions);
    }
    public handleSizeChange(val) {
        console.log('handleSizeChangeval' + JSON.stringify(val));

        this.paginationOptions.count = val;
        this.paginationOptions.currentPage = 1;
        this.handleCurrentChange(this.paginationOptions.currentPage);
        if (Math.ceil(this.total / val) < this.paginationOptions.currentPage) {
            this.paginationOptions.skip = 0;
        } else {
            this.paginationOptions.skip = (this.paginationOptions.currentPage - 1) * this.paginationOptions.count;
        }
    }

    getRowClass(row) {
        let data = row.row;
        let res = [];
        if (data.hasOldTimes) {
            res.push('row-expand-has');
            return res;
        } else {
            res.push('row-expand-unhas');
            return res;
        }
    }
}
